import { render, staticRenderFns } from "./payment-section.vue?vue&type=template&id=66158c96&scoped=true&lang=pug&"
import script from "./payment-section.vue?vue&type=script&lang=ts&"
export * from "./payment-section.vue?vue&type=script&lang=ts&"
import style0 from "./payment-section.vue?vue&type=style&index=0&id=66158c96&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66158c96",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
